export const TOAST_DURATION = {
    MIN: 3000,
    MAX: 8000,
    PER_WORD: 400,
}

export const getToastDuration = (message, severity = 'info') => {
    if (!message || typeof message !== 'string') {
        return TOAST_DURATION.MIN
    }

    const wordCount = message.trim().split(/\s+/).length

    let duration = TOAST_DURATION.MIN + wordCount * TOAST_DURATION.PER_WORD

    if (severity === 'error') {
        duration = Math.max(duration, 4000)
    }

    duration = Math.min(duration, TOAST_DURATION.MAX)

    return duration
}
